import React from "react";
import { useOutletContext } from "react-router-dom";
import DashboardHeader from "../../components/Other/DashboardHeader";
import CandleAnatomyRead from "../../components/Edge/reads/candleAnatomy/CandleAnatomyRead";
import "../../components/Edge/core/edge.css";

// The Edge — Candle Anatomy, Phase 1 prototype. Reachable by URL only
// (/edge/candle-anatomy); no menu entry until the client approves the phase.
function CandleAnatomyPage() {
  const [sidebarToggle] = useOutletContext();
  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      {/* md:ml-60 clears the desktop sidebar and pb-24 the mobile bottom nav, as
          on League Play. Top: pt-14 on mobile only clears the fixed header and
          nothing more (the Contest wizard pages' mobile offset) — the lesson has
          no heading band to fill a larger gap. Desktop keeps pt-24. */}
      <div className="md:ml-60 bg-white pt-14 md:pt-24 pb-24 md:pb-16">
        <div className="max-w-screen-xl mx-auto px-4 md:px-8">
          <div className="mx-auto max-w-[560px] rounded-2xl border border-gray-200 bg-white p-4 md:p-6">
            <CandleAnatomyRead />
          </div>
        </div>
      </div>
    </>
  );
}

export default CandleAnatomyPage;
